import React, { Fragment, useState } from "react";
import {
  Button,
  Card,
  CardBody,
  CardHeader,
  Col,
  Collapse,
  Input,
  Label,
} from "reactstrap";

const JobTitleClass = () => {
  const [isFilter, setIsFilter] = useState(true);
  return (
    <Fragment>
      <Col xl="12">
        <Card>
          <CardHeader>
            <h5 className="mb-0 p-0">
              <Button
                className="btn btn-link border-0 border-bottom"
                onClick={() => setIsFilter(!isFilter)}
                color="transperant"
              >
                Job Title
              </Button>
            </h5>
          </CardHeader>
          <Collapse isOpen={isFilter}>
            <CardBody className="animate-chk border-0">
              <div className="job-filter mb-3">
                <div className="faq-form">
                  <Input
                    className="form-control"
                    type="text"
                    placeholder="location.."
                  />
                  <i className="search-icon" data-feather="map-pin"></i>
                </div>
              </div>
              <Label className="d-block" for="chk-ani11">
                <Input
                  className="checkbox_animated"
                  id="chk-ani11"
                  type="checkbox"
                />
                UI/Ux designer(25)
              </Label>
              <Label className="d-block" for="chk-ani12">
                <Input
                  className="checkbox_animated"
                  id="chk-ani12"
                  type="checkbox"
                />{" "}
                Graphic designer(10)
              </Label>
              <Label className="d-block" for="chk-ani13">
                <Input
                  className="checkbox_animated"
                  id="chk-ani13"
                  type="checkbox"
                />{" "}
                Front end designer(15)
              </Label>
              <Label className="d-block" for="chk-ani14">
                <Input
                  className="checkbox_animated"
                  id="chk-ani14"
                  type="checkbox"
                />{" "}
                PHP developer(42)
              </Label>
              <Label className="d-block mb-0" for="chk-ani15">
                <Input
                  className="checkbox_animated"
                  id="chk-ani15"
                  type="checkbox"
                />
                React Developer(5)
              </Label>
              <Button
                className="btn mt-3 d-block w-100 text-center"
                color="primary"
                type="button"
              >
                All Job Title
              </Button>
            </CardBody>
          </Collapse>
        </Card>
      </Col>
    </Fragment>
  );
};

export default JobTitleClass;
